module.exports = __webpack_public_path__ + "img/icon_clashofcats.2a228e66.jpg";